import Splide from '@splidejs/splide';

document
    .querySelectorAll('.menu_button')
    .forEach(element => {
        element.addEventListener('click', () => {
            document
                .querySelector('.menu')
                .classList
                .toggle('active');
        });
    });

// Splide
const clientCarousel = document.getElementById('clients-carousel');
const testimonialCarousel = document.getElementById('testimonial-carousel');

if (clientCarousel){
    new Splide(clientCarousel, {
        perPage: 7,
        perMove: 1,
        arrows: true,
        type: 'loop',
    }).mount();
}

if (testimonialCarousel) {
    const test = new Splide( testimonialCarousel,{
        perPage: 1,
        perMove: 1,
        arrows: false,
        type: 'loop',
    }).mount();
}